import { render, staticRenderFns } from "./AddProgramForm.vue?vue&type=template&id=514561fd&"
import script from "./AddProgramForm.vue?vue&type=script&lang=js&"
export * from "./AddProgramForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports